<template lang="pug">
.button-action-container
  button.button-action(
    ref="Button"
    :class="buttonClass"
    @click.stop="runAction"
    :style="buttonStyle"
    :title="isIconOnly ? text : undefined"
    :aria-label="isIconOnly ? text : undefined"
  )
    template(v-if="isIconOnly")
      span.material-symbols-outlined.button-action__icon(:class="{ 'is-loading': isWaiting }") {{ icon }}
    template(v-else)
      .text-action(:class="{ disable: isWaiting, 'color-red dark': warning }") {{ isWaiting ? textRunning : text }}
      .bar-action(:class="{ active: isWaiting }")

  shActionButtonConfirmation(v-if="showConfirmation" :textConfirmation="textConfirmation" @accept="runAction" @close="showConfirmation = false")
</template>

<script>
import shActionButtonConfirmation from '@/components/elements/ActionButtonConfirmation'

export default {
  name: 'ActionButton',

  props: {
    isForm: { type: Boolean, default: false },
    mini: { type: Boolean, default: false },
    text: { type: String, default: 'Enviar' },
    textRunning: { type: String, default: 'Ejecutando' },
    action: { type: Function, default: () => {} },
    params: { type: Array, default: () => [] },
    normalColor: { type: Boolean, default: false },
    principalColor: { type: Boolean, default: false },
    textConfirmation: { type: String, default: '' },
    warning: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    width: { type: String, default: 'auto' },
    icon: { type: String, default: '' }
  },

  components: { shActionButtonConfirmation },

  data () {
    return {
      isWaiting: false,
      showConfirmation: false
    }
  },

  computed: {
    isIconOnly () {
      return !!this.icon
    },

    buttonClass () {
      return {
        active: this.isWaiting,
        form: this.isForm,
        medium: this.medium,
        mini: this.mini && !this.isIconOnly,
        disabled: this.disabled,
        'normal-color': this.normalColor,
        'principal-color': this.principalColor,
        'icon-only': this.isIconOnly
      }
    },

    buttonStyle () {
      if (this.isIconOnly) return {}
      return { width: this.width }
    }
  },

  methods: {
    async runAction () {
      if (this.disabled) return

      if (this.isForm) {
        const $Button = this.$refs.Button
        const $Form = $Button.form
        if (!$Form.reportValidity()) return
      }

      if (this.textConfirmation && !this.showConfirmation) {
        this.showConfirmation = true
        return
      }

      if (this.showConfirmation) this.showConfirmation = false

      if (!this.isForm) {
        const event = window.event
        if (event && event.preventDefault) event.preventDefault()
      }

      if (this.isWaiting) return

      this.isWaiting = true
      await this.action(...this.params)
      this.isWaiting = false
    }
  }
}
</script>

<style lang="stylus">
@import '~@/stylus/functions.styl'

.button-action-container
  display inline-flex

.button-action, .button-action.form
  display inline-flex
  justify-content center
  align-items center
  padding 1em 1.6em
  borderRadius(.3rem)
  cursor pointer
  noSelect()
  background transparent
  position relative
  overflow hidden
  border 1px solid rgba(0, 0, 0, .3)
  font-size 1rem
  height 1rem
  text-transform uppercase

.button-action.medium
  padding 1.2em 3em

.button-action.disabled
  background-color rgba(0, 0, 0, .1)
  opacity .5
  cursor default

.button-action.form
  background-color var(--color-principal)
  border none
  padding 1.3em 2em
  color white

.button-action:active, .button-action:focus
  transform none
  outline 0

.button-action.active
  cursor default

.button-action.active:hover, .button-action.active:active, .button-action.active:focus
  transform none

.bar-action
  position absolute
  bottom 0
  left -100%
  width 100%
  height 1px
  background-color rgb(100, 100, 100)
  animation bar 1s 0s infinite forwards
  animation-timming-function ease-in-out
  z-index 1
  borderRadius(.3em)
  animation-name none

.bar-action.active
  animation-name bar

.text-action
  position relative
  z-index 2
  white-space nowrap

.text-action.disable
  color rgb(140, 140, 140)

.mini
  font-size .8em !important

.button-action.form.normal-color
  background-color initial
  border 1px solid rgb(200, 200, 200)
  padding 1em 1.6em
  color #000

.principal-color
  background-color var(--color-principal)
  color white

.button-action.icon-only
  padding 0
  border none
  height auto
  min-height 0
  background transparent
  line-height 1
  -webkit-tap-highlight-color transparent
  touch-action manipulation

.button-action.icon-only.normal-color
  border none
  padding 0
  background transparent

.button-action.icon-only:active:not(.disabled):not(.active)
  opacity .7

.button-action.icon-only.disabled
  background transparent
  opacity .35

.button-action__icon
  display block
  font-size 1.75rem
  line-height 1
  color var(--color-font-principal, #363636)
  transition opacity .2s ease

.button-action.icon-only.normal-color .button-action__icon
  color var(--color-font-principal, #363636)

.button-action.icon-only.principal-color .button-action__icon
  color #fff

.button-action__icon.is-loading
  animation button-action-icon-pulse 1s ease-in-out infinite

@keyframes button-action-icon-pulse
  0%, 100%
    opacity .35
  50%
    opacity 1

@keyframes bar
  0%
    left -100%
  50%
    left 110%
  100%
    width -100%
</style>



// WEBPACK FOOTER //
// src/components/elements/ActionButton.vue